<script lang="ts" setup>
import { FontAwesomeIcon } from '@shared/plugin/icons';

const props = withDefaults(
  defineProps<{
    label?: string;
    disabled?: boolean;
    readonly?: boolean;
  }>(),
  {
    disabled: false,
    readonly: false,
  },
);

const emit = defineEmits<{
  remove: [];
}>();
</script>

<template>
  <span
    :aria-label="props.label"
    :class="[
      'm-[.1875rem] inline-flex items-center em-px-2 py-[.3125rem] text-[.8em] text-white',
      {
        'cursor-pointer bg-secondary hover:bg-secondary-300': !disabled,
        'bg-grey-400': disabled,
      },
    ]"
  >
    <span class="max-w-60 truncate">{{ label }}</span>

    <button
      v-if="!disabled"
      class="ml-2 flex size-4 items-center justify-center bg-black/20 text-white hover:bg-black/30"
      type="button"
      @click="emit('remove')"
    >
      <FontAwesomeIcon class="font-bold" icon="fa-regular fa-times" />
    </button>
  </span>
</template>
